import "../../../styles/kisiler.css";
import { initKisilerFilters, resetKisilerFilters } from "./kisilerFilters.js";
import { initKisilerGridEvents } from "./kisilerGrid.js";
import { initKisilerCreateDialog } from "./dialogs/create/createDialog.js";
import { initKisilerDeleteDialog } from "./dialogs/deleteDialog.js";
import { initKisilerOverviewDialog } from "./dialogs/overviewDialog.js";
import { initKisilerEditDialog } from "./dialogs/editDialog.js";

let initialized = false;

function ensureKisilerView() {
    if (document.getElementById("kisiler-view")) return;
    document.getElementById("page-content").insertAdjacentHTML("beforeend", `
<div id="kisiler-view">
    <div class="page-section" id="kisiler-filter-section">
        <div class="section-header">
            <div class="section-header-left">
                <span class="material-icons section-icon">filter_list</span>
                <span class="section-title">Filtreler</span>
                <span class="filter-aktif-badge" hidden>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                    </svg>
                    Filtre aktif
                </span>
            </div>
            <div class="section-header-right">
                <button class="kisiler-collapse-btn section-collapse-btn" title="Daralt/Genişlet">
                    <span class="material-icons">expand_less</span>
                </button>
            </div>
        </div>
        <div class="section-body">
            <div class="kisiler-filter-row">
                <div class="column-container">
                    <label for="kisiler-departman">Departman</label>
                    <select id="kisiler-departman"><option value="">Tümü</option></select>
                </div>
                <div class="column-container">
                    <label for="kisiler-unvan">Ünvan</label>
                    <select id="kisiler-unvan"><option value="">Tümü</option></select>
                </div>
                <div class="column-container">
                    <label for="kisiler-tc-filter">T.C. Kimlik No</label>
                    <input type="text" id="kisiler-tc-filter" placeholder="TC ile ara..." maxlength="11" inputmode="numeric" />
                </div>
                <div class="column-container">
                    <label for="kisiler-ad-filter">Ad</label>
                    <input type="text" id="kisiler-ad-filter" placeholder="Ada göre ara..." maxlength="100" />
                </div>
                <div class="column-container">
                    <label for="kisiler-soyad-filter">Soyad</label>
                    <input type="text" id="kisiler-soyad-filter" placeholder="Soyada göre ara..." maxlength="100" />
                </div>
                <div class="column-container">
                    <label for="kisiler-durum-filter">Durum</label>
                    <select id="kisiler-durum-filter">
                        <option value="">Tümü</option>
                        <option value="1">Aktif</option>
                        <option value="0">Pasif</option>
                    </select>
                </div>
                <div class="filter-button-container">
                    <button class="kisiler-filter-reset">Temizle</button>
                    <button class="kisiler-search">Ara</button>
                </div>
            </div>
        </div>
    </div>
    <div class="page-section" id="kisiler-table-section">
        <div class="section-header">
            <div class="section-header-left">
                <span class="section-title">Kişiler</span>
                <span class="section-count" id="kisiler-count"></span>
            </div>
            <div class="section-header-right">
                <button class="kisiler-ekle btn-header-action btn-header-action--primary">
                    <span class="material-icons">add</span>
                    Ekle
                </button>
            </div>
        </div>
        <div class="section-body">
            <div class="kisiler-table-grid"></div>
        </div>
    </div>
</div>`);
}

export function renderKisilerPage() {
    ensureKisilerView();
    initKisilerFilters();
    initKisilerGridEvents();
    initKisilerCreateDialog();
    initKisilerDeleteDialog();
    initKisilerOverviewDialog();
    initKisilerEditDialog();

    if (!initialized) {
        initialized = true;
        initKisilerSectionCollapse();
    }
}

function initKisilerSectionCollapse() {
    document.querySelectorAll("#kisiler-view .section-collapse-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
            btn.closest(".page-section").classList.toggle("collapsed");
        });
    });
}

export function resetKisilerPage() {
    resetKisilerFilters();
}
